import { useTar } from '@/modules'
import { Button, GoogleIcon } from '@duck/ui'
import { StandardLoader } from '../StandardLoader'

interface GoogleSignInButtonProps {
  onClick: () => void
  isLoading: boolean
  isDisabled: boolean
}

export const GoogleSignInButton = ({ onClick, isLoading, isDisabled }: GoogleSignInButtonProps) => {
  const { t } = useTar()
  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      className={`w-full flex items-center justify-center gap-3 px-4 py-3 border border-border rounded-lg 
               bg-card text-foreground transition-colors duration-200 focus:outline-none
               ${isDisabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:bg-accent hover:text-white'
        }`}
    >
      {isLoading ? (
        <>
          <StandardLoader size="sm" />
          <span className="font-medium">{t('common.loading')}</span>
        </>
      ) : (
        <>
          <GoogleIcon size={20} className="w-5 h-5" />
          <span className="font-medium">{t('common.continueWithGoogle')}</span>
        </>
      )}
    </Button>
  )
} 